"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsonToCsvExport = _interopRequireDefault(require("json-to-csv-export"));
var _excluded = ["data", "filename", "delimiter", "headers"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CsvDownloadButton = function CsvDownloadButton(props) {
  var data = props.data,
    filename = props.filename,
    delimiter = props.delimiter,
    headers = props.headers,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    onClick: function onClick() {
      return (0, _jsonToCsvExport["default"])({
        data: data,
        filename: filename,
        delimiter: delimiter,
        headers: headers
      });
    }
  }, others), props.children || 'Download Data');
};
var _default = CsvDownloadButton;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-json-to-csv/dist/index.js
// module id = 1439
// module chunks = 0